import config from 'config';
import tmpl from './view.phtml';
import View from 'lib/View';
import * as repo from 'db/repositories';

export default View.extend({
	template: tmpl,

	events: {
		'click #visit_sync': 'sendVisit',
		'click #visit_delete_modal_confirm': 'deleteVisit'
	},

	initialize: function()
	{
		var render = _.debounce( this.render, 100 )
		this.listenTo( this.model, 'all', render );
		this.listenTo( this.model.getPond(), 'all', render );
		this.listenTo( app, 'online', render );
	},

	sendVisit: function()
	{
		this.model.set( 'todo', this.model.isNew() ? 'create' : 'update' );
		app.persistModel( this.model ).then( function()
		{
			app.commit();
		} );
	},

	deleteVisit: function()
	{
		if( this.model.isNew() )
		{
			repo.putVisit( _.extend( this.model.toJSON(), { deleted_at: Date.now() } ) ).then( function()
			{
				app.redirect('visit/draft');
			} );
		}
		else
		{
			this.model.set('todo','delete');
			app.persistModel( this.model ).then( function()
			{
				app.commit();
				app.redirect('visit/sent');
			} );
		}
	},

	render: function()
	{
		this.doRender({
			visit: this.model,
			pond: this.model.getPond(),
			form: app.getStore('data').get('form'),
			error: this.model.getErrors()
		});
	}
});
